"use client";

import { Sparkles } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@heroui/popover";
import { Button } from "@heroui/button";
import { useState, useEffect } from "react";

export default function AISummary({ summary }) {
  // Add a mounted state to track hydration
  const [mounted, setMounted] = useState(false);

  // Set mounted flag after hydration is complete
  useEffect(() => {
    setMounted(true);
  }, []);

  // For server-rendering, return a simpler version without the popover
  if (!mounted) {
    return (
      <Button variant="flat" startContent={<Sparkles size={16} />}>
        AI summary
      </Button>
    );
  }

  // Client-side only rendering after hydration
  return (
    <Popover
      placement="bottom"
      backdrop="blur"
      containerPadding={16}
      size="md"
      radius="sm"
      shouldBlockScroll
    >
      <PopoverTrigger>
        <Button variant="flat" startContent={<Sparkles size={16} />}>
          AI summary
        </Button>
      </PopoverTrigger>
      <PopoverContent className="max-w-full p-4 lg:w-96">
        <div className="flex items-center bg-gradient-to-tr from-purple-600 to-cyan-500 bg-clip-text pb-2 font-mono text-sm text-transparent dark:from-purple-400 dark:to-cyan-400">
          <div className="mr-2 flex h-8 w-8 shrink-0 items-center justify-center  rounded-full bg-gradient-to-tr from-purple-500 to-cyan-500 ">
            <Sparkles className="size-4 text-white" />
          </div>
          <a
            href="https://apps.apple.com/gb/app/arti/id1659936985"
            target="_blank"
            rel="noreferrer"
            className="font-bold underline decoration-cyan-500 decoration-2 underline-offset-4"
          >
            Arti
          </a>
        </div>
        {summary}
      </PopoverContent>
    </Popover>
  );
}
